<template>
  <div
    class="choose-practice-row"
    :class="user.selected ? 'selected' : ''"
    @click="$emit('to-user', { id: user.id, value: !user.selected })"
  >
    <div class="choose-practice-col">
      <div class="choose-practice__checkbox">
        <v-icon v-if="!user.selected">bhi-ellipse</v-icon>
        <v-icon v-else>bhi-check-circle-filled</v-icon>
      </div>
    </div>
    <div class="choose-practice-col">
      <div class="choose-practice__avatar">
        <lazy-image
          wrapperClass="choose-practice__avatar"
          :src="user.thumbnailUrl"
          :fallback="require('@/assets/loggedPlaceholder96x96.png')"
          :alt="user.name"
        />
      </div>
    </div>
    <div class="choose-practice-col">
      <h4 @click="$emit('to-user', user.id)" class="choose-practice__name">
        {{ user.name }}
      </h4>
      <span class="pr-2">{{ user.isActive ? 'Active' : 'Inactive' }}</span>
    </div>
    <div class="choose-practice-col">
      <p class="pr-2 mb-1 accent--text">
        {{ user.pcFirstName }} {{ user.pcLastName }}
      </p>
    </div>
  </div>
</template>

<script>
import LazyImage from '../lazy/LazyImage.vue'
export default {
  components: { LazyImage },
  name: 'ChoosePracticeTableRow',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="scss">
.choose-practice {
  &__name {
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
    cursor: pointer;
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    .v-image {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &__checkbox {
    width: 30px;
    text-align: center;
    .v-icon {
      color: $bh-blue;
    }
  }

  &-row {
    display: flex;
    align-items: center;
    background: $bh-white;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;
    cursor: pointer;
    border: 2px solid $bh-white;
    &.selected {
      border: 2px solid $bh-blue;
    }
    &:hover {
      background: $bh-white !important;
      border: 2px solid $bh-blue--3;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: right;
    }

    .text-number {
      font-size: 1.125rem;
    }
  }
}
</style>
